/**
* 配置文件
*/

const CNF = {
    'api': process.env.REACT_APP_API,
    'cfmsApi': process.env.REACT_APP_CFMS_API,
    'ossApi': process.env.REACT_APP_OSS_API,
    'accountUrl': process.env.REACT_APP_ACCOUNT_URL,
    'projectCode': 'VSPA',
    'projectName': '点位',
    'projectFullname': '点位档案综合管理系统',       // 项目全称
    'companyShortName': '新致腾',                   //  公司简称
    'version': '1.0.3',
    'mainUrl': '',                                // 主页地址
    'homeUrl': process.env.REACT_APP_HOME_URL,    // 首页地址
    'loginUrl': process.env.REACT_APP_LOGIN_URL,  // 登录地址
    'userUrl': process.env.REACT_APP_USER_URL,    // 设置地址
    'timeZone': 'Asia/Shanghai',                    // 时区   
    'locale': 'zhCN',                               // antd国际化语言
    'themeColors': [    //可选主题颜色
        '#fa541c',
        '#1677ff',
        '#13c2c2',
        '#722ed1',
        '#fa8c16',
        '#f5222d',
        '#52c41a',
        '#eb2f96',
        '#a0d911',
        '#faad14',
    ],
    'isDisplayTableBorder': 0,                         // 是否显示表格边框
    'cookies': {
        'keySecure': true,
        'keyPath': '/',
        'keyDomain': process.env.REACT_APP_COOKIE_DOMAIN,
        'keyExpire': 2592000,
        'keyUid': 'login_xzt_uid',
        'keyId': 'login_xzt_id',
        'keyToken': 'login_xzt_token',
        'keyUsername': 'login_xzt_username',
        'keyDisplayname': 'login_xzt_displayname',
        'keyAvatarUrl': 'login_xzt_avatar_url',
        'keyThemeColor': 'login_xzt_theme_color',
        'keyIsDisplayTableBorder': 'login_xzt_is_display_table_border',
    },
    'timeout': 5000,
    'tDivisor': 9999999999,
    'maxAge': 3600,
    'fontSize': 14,                          // 字体大小
    'menuHeight': '44px',
    'menuLineHeight': '40px',
    'messageDuration': 1.5,                  // 消息弹框持续时间，单位秒
    'animateDuration': 2000,                 // 动画持续时间，单位秒
    'screenWidth': 1792,                     // 系统屏幕宽度
    'searchMarginLeft': 5,                   // 搜索栏左边距
    'rowMarginTop': 10,                      // 行距顶部高度
    'lineHeight': 2.2,                       // 行高
    'tableOperationColumnWidth': 80,         // 表格操作者列宽度
    'tableStatusColumnWidth': 80,            // 表格状态列宽度
    'tableCreateTimeColumnWidth': 120,       // 表格创建时间列宽度
    'tableCreateDisplayeColumnWidth': 90,    // 表格创建者列宽度
    'maxPageSize': 65535,                    //  最大分页数，主要用于下拉列表
    'pageSize': 10,
    'DPL': 2,
    'currentTheme': 'default',  //  当前主题
    'swatches': {   //  色板
        'default': ['#1983FF', '#07C9CA', '#F0884D', '#D580FF', '#7963FF', '#BD8F25', '#60C42E', '#FF80CA', '#2492B3', '#18C86F'],
    },
    'currentSwatche': 'default', // 当前色板
    'status': [ // 状态
        { 'key': '激活', 'value': '激活' },
        { 'key': '禁用', 'value': '禁用' },
    ],
    'navItems': [
        {
            'url': '/pointLocation/collects', 'icon': '', 'm': 1, 'name': '点位管理', 'ptn': 'btn_vspa_point_location', 'sub': 'sub1', 'submenu': [
                { 'url': '/pointLocation/collects', 'name': '点位采集', 'icon': '', 'm': 11, 'ptn': 'btn_vspa_point_location_collect', 'isLogModule': true },
                { 'url': '/pointLocation/infos', 'name': '点位信息', 'icon': '', 'm': 12, 'ptn': 'btn_vspa_point_location_info', 'isLogModule': true }
            ]
        },
        {
            'url': '/reports', 'icon': 'message', 'm': 2, 'name': '统计报表', 'ptn': 'btn_vspa_report', 'sub': 'sub2', 'submenu': [
                { 'url': '/report/pointLocationInfo/dcim', 'name': '安装方式分类统计', 'icon': '', 'm': 21, 'ptn': 'btn_vspa_report_point_location_info_dcim', 'isLogModule': false },
            ]
        },
        {
            'url': '/logs', 'icon': 'MessageOutlined', 'm': 3, 'name': '日志管理', 'ptn': 'btn_vspa_log', 'sub': 'sub3', 'submenu': [
                { 'url': '/log/operations', 'name': '操作日志', 'icon': '', 'm': 31, 'ptn': 'btn_vspa_log_operation', 'isLogModule': false },
            ]
        }
    ],
    'focusStyle': {
        lineHeight: 2.2,
        paddingLeft: 5,
        color: 'red'
    },
    'actionName': { // 动作名称
        'CREATE': '新增',
        'UPDATE': '修改',
        'IMPORT': '导入',
        'EXPORT': '导出',
        'ACTIVE': '激活',
        'DISABLE': '禁用',
        'DELETE': '删除',

    },
    'installationMethod': [ //  安装方式
        { label: '立杆', value: '立杆' },
        { label: '附墙', value: '附墙' },
        { label: '借杆', value: '借杆' },
        { label: '吊装', value: '吊装' },
        { label: '其他', value: '其他' },
    ],
    'pointLocationImageMaxCount': 1,
    'pointLocationExportTemplates': [
        { 'key': '默认模版', value: 'PLCS.docx' },
        { 'key': '无双拼模版', value: 'PLCS_NO_DOUBLE_PINYIN.docx' },
    ],
}

export default CNF;